/**
 * The devices a composer can start or move a session on (RFC 0261 slice 3):
 * every device beating in the World, plus the harnesses the desktop shell has
 * already found on this machine. One hook so the thread, the new pane and the
 * session list offer the same harnesses.
 */

import { withLocalHarnessDevices } from '@mod/core/run'
import { useMemo } from 'react'
import { useLocalHarnesses } from './useLocalHarnesses'
import { useWorldDevices } from './useWorldDevices'

export function useComposerDevices() {
  const presentDevices = useWorldDevices()
  const localHarnesses = useLocalHarnesses()
  return useMemo(
    () =>
      withLocalHarnessDevices(
        presentDevices.map((d) => ({
          deviceId: d.deviceId,
          name: d.name,
          ...(d.harnesses ? { harnesses: d.harnesses } : {}),
        })),
        localHarnesses,
      ),
    [presentDevices, localHarnesses],
  )
}
